import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { NetworkTreeBaseDataProvider } from '../dataProvider/NetworkTreeBaseDataProvider';
import { NetworkTreeDataProviderFactory } from '../factory/NetworkTreeDataProviderFactory';
import { NodeData } from '../../../ui/gzTree/type';
import { NetworkTreeStructure, TreeDetails } from '../types';

export class NetworkTreeRepository extends BaseWebComponentRepository {
  public dataProvider: NetworkTreeBaseDataProvider;
  public dataProviderFactory: NetworkTreeDataProviderFactory;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new NetworkTreeDataProviderFactory(),
    });
  }

  public getRootNode(): Promise<NodeData> {
    return this.dataProvider.getRootNode();
  }

  // this performs authorization by checking if user has access to targetNode.nodeId
  public getNodeChildren(targetNode: NodeData): Promise<{ currentNode: NodeData; childNodes: NodeData[] }> {
    return this.dataProvider.getNodeChildren(targetNode);
  }

  // this performs authorization by checking if user has access to treeDetails.targetId
  public async getTreeNodesForChild(treeDetails: TreeDetails, rootNode: NodeData): Promise<NetworkTreeStructure> {
    const response = await this.dataProvider.getTreeNodesForChild(treeDetails);

    rootNode.originalData.realNode = response.realNode;
    rootNode.hasMoreChildNodes = response.hasMoreChildNodes;
    rootNode.loadedPage = response.page;

    return {
      rootNode,
      data: response.data,
    };
  }
}
